// extracted by mini-css-extract-plugin
var _1 = "ra-card-editorial";
var _2 = "ra-card-editorial-content-wrapper";
var _3 = "ra-card-editorial-description";
var _4 = "ra-card-editorial-extra";
var _5 = "ra-card-editorial-horizontal";
var _6 = "ra-card-editorial-large";
var _7 = "ra-card-editorial-subtitle";
var _8 = "ra-card-editorial-title";
export { _1 as "cardEditorialCls", _2 as "cardEditorialContentWrapperCls", _3 as "cardEditorialDescriptionCls", _4 as "cardEditorialExtraCls", _5 as "cardEditorialHorizontalCls", _6 as "cardEditorialLargeCls", _7 as "cardEditorialSubtitleCls", _8 as "cardEditorialTitleCls" }
